import React, { useState , lazy, Suspense } from 'react';
import axios from 'axios';
import './ContactFilter.scss'; // Import the SCSS module

const ContactFilter = ({ id }) => {
  const [formData, setFormData] = useState({
    fullName: '',
    address: '',
    email: '',
    phone: '',
    message: '',
    contactMethod: [],
    recaptchaResponse: '',
  });
  const [loading, setLoading] = useState(false);
  const ReCAPTCHA = lazy(() => import('react-google-recaptcha'));

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
      setFormData({
        ...formData,
        contactMethod: checked
          ? [...formData.contactMethod, value]
          : formData.contactMethod.filter((method) => method !== value)
      });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleRecaptchaChange = (value) => {
    setFormData({ ...formData, recaptchaResponse: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Ensure reCAPTCHA is completed
    if (!formData.recaptchaResponse) {
      alert('Please confirm you are not a robot.');
      return;
    }

    // Ensure either phone or email is entered
    if (!formData.phone && !formData.email) {
      alert('Please enter either a phone number or an email.');
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post('https://filterspamthree-slxtnq4k5a-uc.a.run.app', formData);
      if (response.data.isSpam === "spam") {
        console.log('Spam detected', response.data);
        window.location.href = '/thank-you-1';

      } else if (response.data.isSpam === "buyer") {
        console.log('Buyer detected', response.data);
        window.location.href = '/thank-you-3';
      } else {
        console.log('Seller detected', response.data);
        window.location.href = '/thank-you-2';
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Submission error: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div id={id} className={`contact-filter ${loading ? 'loading' : ''}`}>
      {loading && <div className="loading-spinner"></div>}
      <h1 className='headline-title'>CONTACT US</h1>
      <form onSubmit={handleSubmit}>
      <p className='headline-text'>
        Get in touch today to book in your <span className='free-text'>FREE VALUATION</span> or to ask any questions.
      </p>

        <div className="row">
          <div className='contact-filter-group'>
            <label htmlFor="fullName" className='contact-filter-label'>Full Name</label>
            <input
              type="text"
              id="fullName"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              disabled={loading}
              required
            />
          </div>
          <div className='contact-filter-group'>
            <label htmlFor="address" className='contact-filter-label'>Area</label>
            <select
              id="address"
              name="address"
              value={formData.address}
              onChange={handleChange}
              disabled={loading}
              required
            >
              <option value="" disabled>Select your area</option>
              <option value="Chester Le Street">Chester Le Street</option>
              <option value="Consett">Consett</option>
              <option value="Crawcrook">Crawcrook</option>
              <option value="Durham">Durham</option>
              <option value="Houghton-le-Spring">Houghton-le-Spring</option>
              <option value="Lowfell">Lowfell</option>
              <option value="Rowlandsgill">Rowlandsgill</option>
              <option value="Sunderland">Sunderland</option>
              <option value="Wallsend">Wallsend</option>
              <option value="Washington">Washington</option>
              <option value="West Denton">West Denton</option>
              <option value="Whickham">Whickham</option>
              <option value="Winlaton">Winlaton</option>
              <option value="Whitley Bay">Whitley Bay</option>
            </select>
          </div>
        </div>
        <div className='row'>
          <div className='contact-filter-group'>
            <label htmlFor="email" className='contact-filter-label'>Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              disabled={loading}
            />
          </div>
          <div className='contact-filter-group'>
            <label htmlFor="phone" className='contact-filter-label'>Phone</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              disabled={loading}
            />
          </div>
        </div>
        <div className='contact-filter-group'>
          <label htmlFor="message" className='contact-filter-label'>Message</label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            disabled={loading}
            required
          />
        </div>
        <div className='prefered-method'>
          <p>Prefered contact method:</p>
        </div>
        <div className='checkbox-group'>
          <label>
            <input
              type="checkbox"
              name="contactMethod"
              value="phone"
              onChange={handleChange}
              disabled={loading}
            />
            Phone
          </label>
          <label>
            <input
              type="checkbox"
              name="contactMethod"
              value="email"
              onChange={handleChange}
              disabled={loading}
            />
            Email
          </label>
        </div>
        <div className='recaptcha-container'>
        <Suspense fallback={<div>Loading video...</div>}>
          <ReCAPTCHA
            sitekey="6LfzhRcqAAAAAAEA-oT1hx7-J0hQgky6v8EopE6V"
            onChange={handleRecaptchaChange}
            disabled={loading}
          />
        </Suspense>
        </div>
        <button type="submit" disabled={loading}>Submit</button>
      </form>
    </div>
  );
};

export default ContactFilter;
